<script>
// Extensions
import View from '@/views/Public/View';

// Mixins
import LoadSections from '@/mixins/load-sections';

export default {
    name: 'Home',

    metaInfo: { title: 'Home' },

    extends: View,

    mixins: [
        LoadSections([
            'hero',
            'about-our-product',
            'features',
            'theme-features',
            'recent-works',
            'contact-us',
            'affiliates',
            'info-alt'
        ])
    ],

    props: {
        id: {
            type: String,
            default: 'home'
        }
    }
};
</script>
